import {observable} from 'mobx';

const uuidv4 = require('uuid/v4');

export interface AbstractEntityData {}

export abstract class AbstractEntity<T extends AbstractEntityData> {
  readonly id: string;
  @observable protected data: T;

  constructor(data: T) {
    this.data = data;
    this.id = uuidv4();
  }
}
